<div class="policyWidget beneWidget mmDirectWidget">
  <div class="wrap wrapClose">
    <div class="wrapClose__content header">
      <div class="header__content">
        <div class="header__logo-image wrapClose__logo" alt="MMDirect"></div>
        <button type="button" class="close" (click)="checkCancel();">Close</button>
      </div>
    </div>
  </div>

  <div class="wrap wrapHead">
    <div class="pageHead">
      <legend>Add custodian</legend>
    </div>
  </div>

  <div class="wrap wrapMain">
    <form class="custodianForm mmDirectForm" [formGroup]="custodianForm">
      <div class="formRow">
        <div class="split-row-col2">
          <div class="first colLeft">
            <basic-text-input
              [propertyName]="'firstName'"
              [placeholder]="'First name'"
              [parserType]="'Text'"
              [inputType]="'text'"
              type="text"
              formControlName="firstName"
              [formGroupComponent]="true"
            ></basic-text-input>
          </div>
          <div class="last colRight">
            <basic-text-input
              [propertyName]="'lastName'"
              [placeholder]="'Last name'"
              [parserType]="'Text'"
              [inputType]="'text'"
              type="text"
              formControlName="lastName"
              [formGroupComponent]="true"
            ></basic-text-input>
          </div>
        </div>
      </div>
      <div class="formElem state">
        <select-basic
          [propertyName]="'state'"
          [placeholder]="'State'"
          [optionValues]="stateList"
          formControlName="state"
          [formGroupComponent]="true"
        ></select-basic>
      </div>
    </form>
    <div class="fineprint">
      UTMA/UGMA refers to a state's law that governs the transfer of title to life insurance proceeds to a Custodian to
      manage for a minor until the minor reaches an age permitted by law. Under the UTMA/UGMA of the state designated
      above, the person designated above will be Custodian for the child(ren) named in the Beneficiary section. These
      custodial arrangements may only be used in states where permitted by applicable law.
    </div>
  </div>

  <div class="wrap wrapFoot">
    <div class="cta">
      <button
        type="submit"
        class="btnSubmit"
        [disabled]="(custodianForm.invalid || validate())"
        (click)="saveCustodian()"
      >
        Submit
      </button>
      <button type="button" class="btnCancel" (click)="cancel()">Cancel</button>
    </div>
  </div>
</div>

<modal *ngIf="modalService.showModal" [dismiss]="dismiss"></modal>
